import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

class CartServices {
    getCart = async (tenantId) => {
      const addresses = await Helpers.get({
        url: `${Constants.CART}${tenantId}/cart`,
      });
      return addresses;
    }

    addToCart = async (payload, tenantId) => {
      const cart = await Helpers.put({
        url: `${Constants.CART}${tenantId}/cart`,
        data: payload,
      });
      return cart;
    }

    getSKUAvailability = async (tenantId, productSkuIds) => {
      let url = `${Constants.MOV2}/product_for_mo?`;
      if (tenantId) url += `tenant_id=${tenantId}&`;
      if (productSkuIds) url += `product_sku_ids=${productSkuIds}&`;
      const sku = await Helpers.get({
        url,
      });
      return sku;
    }
}
export default new CartServices();
